import { Box } from 'reflexbox';

import Checkbox, { CheckboxTypes } from 'packages/kakapo-ui-kit/components/forms/controls/Checkbox';

const ListFilterCheckbox = ({
	options,
}: {
	options: { label: string; name: string; value: string; tintColor?: string }[];
}) => {
	const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
	return (
		<>
			{sortedOptions.map((option, index) => (
				<Box mb={index < options.length - 1 ? 2 : 0} key={index}>
					<Checkbox
						id={option.value}
						name={option.name}
						label={option.label}
						value={option.value}
						checkboxStyle={CheckboxTypes.RoundedRect}
						tintColor={option.tintColor}
					/>
				</Box>
			))}
		</>
	);
};

export default ListFilterCheckbox;
